
import Icon from '../common/Icon';

export default {
  name: 'Button',
  components: {
    Icon,
  },
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    param: String
  },
  computed: {
    btnClasses() {
      return [
        this.blok.variant,
        this.blok.size,
        this.blok.icon_position
      ];
    },
    isDisabled() {
      return !!this.blok.disabled
    },
    isExternalLink() {
      return this.blok.link?.cached_url && this.blok.link?.linktype === 'url'
    },
  },
  methods: {
    handleClick() {
      if (this.isExternalLink) return;

      if (this.blok.emit_event) {
        this.$emit('click', this.blok.emit_event);
        return;
      }
      // this.blok.link?.linktype === 'story'
      else if (this.blok.link?.cached_url) {
        const param = this.param ? `?${this.param}` : ''
        this.$nuxt.$router.push('/' + this.blok.link.cached_url + param)
      }     
    }
  },
};
